// extracted by mini-css-extract-plugin
export default {"keyword":"KeywordItem_keyword__6P+Xw","iconButton":"KeywordItem_iconButton__pIIo1"};